module.exports = __webpack_public_path__ + "img/notifications_selected.385d2b43.svg";